import {NoopScrollStrategy} from "@angular/cdk/overlay";
import {Component} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {LensConfigMode, LensSectionMode} from "src/app/model/configuration/configuration";
import {NewOrderSelectDialogComponent} from "src/app/new-order/new-order-select-dialog/new-order-select-dialog.component";
import {NewOrderStoreService} from "src/app/new-order/new-order-store-service.service";

@Component({
  selector: 'app-new-order-picker',
  templateUrl: './new-order-picker.component.html',
  styleUrls: ['./new-order-picker.component.scss']
})
export class NewOrderPickerComponent {

  constructor(
    private dialog: MatDialog,
    private newOrderStoreService: NewOrderStoreService,
    private router: Router) {
  }

  newOrderLenses() {
    this.dialog.open(NewOrderSelectDialogComponent, {
      data: {
        copy: false
      },
      autoFocus: false,
      width: '650px',
      scrollStrategy: new NoopScrollStrategy()
    });
  }

  newOrderProposal() {
    this.startNewOrder(LensSectionMode.HECHT_PROPOSAL, 'proposal');
  }

  newOrderTrialLens() {
    this.startNewOrder(LensSectionMode.TRIAL_LENS, 'trial-lens');
  }

  newOrderFinalLens() {
    this.startNewOrder(LensSectionMode.FINAL_LENS, 'final-lens');
  }

  newOrderCare() {
    this.startNewOrder(LensSectionMode.CARE, 'care');
  }

  newOrderAccessories() {
    this.startNewOrder(LensSectionMode.ACCESSORIES, 'accessories');
  }

  private startNewOrder(lensSectionMode: LensSectionMode, fragment: string) {
    this.newOrderStoreService.setLensConfigMode(LensConfigMode.DUAL);
    this.newOrderStoreService.setLensSectionMode(lensSectionMode);
    this.newOrderStoreService.setIsLeftSideEnable(true);
    this.newOrderStoreService.setIsRightSideEnable(true);
    this.newOrderStoreService.changeLensSectionMode(lensSectionMode);
    this.router.navigate(['/new-order'], {fragment: fragment}).then((success) => {
        if (fragment) document.getElementById(fragment)?.scrollIntoView();
    });
  }

  isLoading(): boolean {
    return this.newOrderStoreService.finishedLoading == false;
  }
}
